/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { compose } from 'recompose';
import Media from 'react-media';
import MobileRegularUser from './MobileGiftList/Layouts/MobileRegularUser';
import DesktopRegularUser from './DesktopGiftList/Layouts/DesktopRegularUser';
import withPageView from '../../../../helpers/tracking/hocs/withPageView';
import CUSTOM_BREAKPOINTS from '../../style/customBreakpoints';

const RegularUser = () => {
    const breakpointExpr =  `(max-width: ${CUSTOM_BREAKPOINTS.tabLandscape}px)`;
    return (
        <>
            <Media query={breakpointExpr}>
                {(matches) => (       // eslint-disable-line arrow-parens
                    matches ? (
                        <>
                            <MobileRegularUser />
                        </>
                    ) : (
                        <>
                            <DesktopRegularUser />
                        </>
                    )
                )}
            </Media>
        </>
    );
};

const enhance = compose(
    withPageView({
        pageViewSuccessTest: () => true,
    }),
);

export default enhance(RegularUser);
